import { Companion_instancel8ig9z4updma as Companion_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Primitives.mjs';
import {
  serializerodflzzf6s3fp as serializer,
  serializer1hu9wv9at41ww as serializer_0,
  serializer1r0h5yakm679b as serializer_1,
  serializer1tw0a8bv7lkga as serializer_2,
} from '../builtins/BuiltinSerializers.mjs';
import { InlinePrimitiveDescriptor3i6ccn1a4fw94 as InlinePrimitiveDescriptor } from './InlineClassDescriptor.mjs';
import {
  _ULong___get_data__impl__fggpzbbo8lz7f8fnfy as _ULong___get_data__impl__fggpzb,
  ULong3f9k7s38t3rfp as ULong,
  _ULong___init__impl__c78o9k1vasxel72m2l4 as _ULong___init__impl__c78o9k,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  IntCompanionObject_instance3g0jtywew2pgh as IntCompanionObject_instance,
  ByteCompanionObject_instance1r92wkzdy7g72 as ByteCompanionObject_instance,
  ShortCompanionObject_instance33mqksfmw0mrs as ShortCompanionObject_instance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import {
  _UInt___get_data__impl__f0vqqw30ojw38w2y6td as _UInt___get_data__impl__f0vqqw,
  UInt1hthisrv6cndi as UInt,
  _UInt___init__impl__l7qpdl5ip6p2ldulrs as _UInt___init__impl__l7qpdl,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  _UByte___get_data__impl__jof9qr100nrznmlnqj as _UByte___get_data__impl__jof9qr,
  UBytep4j7r1t64gz1 as UByte,
  _UByte___init__impl__g9hnc49zztd2brjj2m as _UByte___init__impl__g9hnc4,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import {
  _UShort___get_data__impl__g02451raj6q6epxg1b as _UShort___get_data__impl__g0245,
  UShort26xnqty60t7le as UShort,
  _UShort___init__impl__jigrne1e3nphhrejdd8 as _UShort___init__impl__jigrne,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ULongSerializerClass;
function ULongSerializer() {
  if (ULongSerializerClass === VOID) {
    class $ {
      constructor() {
        ULongSerializer_instance = this;
        this.descriptor_1 = InlinePrimitiveDescriptor('kotlin.ULong', serializer(Companion_instance));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_2j4ykd_k$(encoder, value) {
        var tmp = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        // Inline function 'kotlin.ULong.toLong' call
        var tmp$ret$0 = _ULong___get_data__impl__fggpzb(value);
        tmp.encodeLong_vlw3uq_k$(tmp$ret$0);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_2j4ykd_k$(encoder, value instanceof ULong() ? value.data_1 : THROW_CCE());
      }
      deserialize_5le3z5_k$(decoder) {
        // Inline function 'kotlin.toULong' call
        var this_0 = decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeLong_jzt186_k$();
        return _ULong___init__impl__c78o9k(this_0);
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ULong())(this.deserialize_5le3z5_k$(decoder));
      }
    }
    initMetadataForObject($, 'ULongSerializer', VOID, VOID, [KSerializer()]);
    ULongSerializerClass = $;
  }
  return ULongSerializerClass;
}
var ULongSerializer_instance;
function ULongSerializer_getInstance() {
  if (ULongSerializer_instance === VOID)
    new (ULongSerializer())();
  return ULongSerializer_instance;
}
var UIntSerializerClass;
function UIntSerializer() {
  if (UIntSerializerClass === VOID) {
    class $ {
      constructor() {
        UIntSerializer_instance = this;
        this.descriptor_1 = InlinePrimitiveDescriptor('kotlin.UInt', serializer_0(IntCompanionObject_instance));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_vaoflw_k$(encoder, value) {
        var tmp = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        // Inline function 'kotlin.UInt.toInt' call
        var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(value);
        tmp.encodeInt_y5zi3z_k$(tmp$ret$0);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_vaoflw_k$(encoder, value instanceof UInt() ? value.data_1 : THROW_CCE());
      }
      deserialize_dkfhli_k$(decoder) {
        // Inline function 'kotlin.toUInt' call
        var this_0 = decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeInt_8iq8f5_k$();
        return _UInt___init__impl__l7qpdl(this_0);
      }
      deserialize_sy6x50_k$(decoder) {
        return new (UInt())(this.deserialize_dkfhli_k$(decoder));
      }
    }
    initMetadataForObject($, 'UIntSerializer', VOID, VOID, [KSerializer()]);
    UIntSerializerClass = $;
  }
  return UIntSerializerClass;
}
var UIntSerializer_instance;
function UIntSerializer_getInstance() {
  if (UIntSerializer_instance === VOID)
    new (UIntSerializer())();
  return UIntSerializer_instance;
}
var UByteSerializerClass;
function UByteSerializer() {
  if (UByteSerializerClass === VOID) {
    class $ {
      constructor() {
        UByteSerializer_instance = this;
        this.descriptor_1 = InlinePrimitiveDescriptor('kotlin.UByte', serializer_1(ByteCompanionObject_instance));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_7dk1zj_k$(encoder, value) {
        var tmp = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        // Inline function 'kotlin.UByte.toByte' call
        var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
        tmp.encodeByte_6txfee_k$(tmp$ret$0);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_7dk1zj_k$(encoder, value instanceof UByte() ? value.data_1 : THROW_CCE());
      }
      deserialize_5l7xnx_k$(decoder) {
        // Inline function 'kotlin.toUByte' call
        var this_0 = decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeByte_jzz7je_k$();
        return _UByte___init__impl__g9hnc4(this_0);
      }
      deserialize_sy6x50_k$(decoder) {
        return new (UByte())(this.deserialize_5l7xnx_k$(decoder));
      }
    }
    initMetadataForObject($, 'UByteSerializer', VOID, VOID, [KSerializer()]);
    UByteSerializerClass = $;
  }
  return UByteSerializerClass;
}
var UByteSerializer_instance;
function UByteSerializer_getInstance() {
  if (UByteSerializer_instance === VOID)
    new (UByteSerializer())();
  return UByteSerializer_instance;
}
var UShortSerializerClass;
function UShortSerializer() {
  if (UShortSerializerClass === VOID) {
    class $ {
      constructor() {
        UShortSerializer_instance = this;
        this.descriptor_1 = InlinePrimitiveDescriptor('kotlin.UShort', serializer_2(ShortCompanionObject_instance));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_ebjbu9_k$(encoder, value) {
        var tmp = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        // Inline function 'kotlin.UShort.toShort' call
        var tmp$ret$0 = _UShort___get_data__impl__g0245(value);
        tmp.encodeShort_gza6si_k$(tmp$ret$0);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_ebjbu9_k$(encoder, value instanceof UShort() ? value.data_1 : THROW_CCE());
      }
      deserialize_vgnfnb_k$(decoder) {
        // Inline function 'kotlin.toUShort' call
        var this_0 = decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeShort_jjqk32_k$();
        return _UShort___init__impl__jigrne(this_0);
      }
      deserialize_sy6x50_k$(decoder) {
        return new (UShort())(this.deserialize_vgnfnb_k$(decoder));
      }
    }
    initMetadataForObject($, 'UShortSerializer', VOID, VOID, [KSerializer()]);
    UShortSerializerClass = $;
  }
  return UShortSerializerClass;
}
var UShortSerializer_instance;
function UShortSerializer_getInstance() {
  if (UShortSerializer_instance === VOID)
    new (UShortSerializer())();
  return UShortSerializer_instance;
}
//region block: exports
export {
  UByteSerializer_getInstance as UByteSerializer_getInstance29ovrhqybz59q,
  UIntSerializer_getInstance as UIntSerializer_getInstance3tg9r9shlxhbj,
  ULongSerializer_getInstance as ULongSerializer_getInstance6th9fj1q70m2,
  UShortSerializer_getInstance as UShortSerializer_getInstance3bith9k7xv4n8,
};
//endregion

//# sourceMappingURL=ValueClasses.mjs.map
